module.exports = __webpack_public_path__ + "img/projectscoreimportoutput.28989dfe.png";